module.exports = __webpack_public_path__ + "static/tkodes-v2.fdd4e454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tkodes-v2.jpg
// module id = 363
// module chunks = 35783957827783